// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsPercent } from '../../../common/helpers.mjs'
import { shouldDisableDiscount } from '../../../js/validate'
import DiscountDescriptionBox from '../../ui-helper-elements/DiscountDescriptionBox'
// Asset Imports

export default function HRImpDealDeskDiscountRow({ order = 1 }) {
   const state = useQuoteContext()
   const discountCode = 'hrDealdesk'
   const { getString } = state

   if (state.user_view == 'Internal' || state.discountDealDeskHRImp)
      return (
         <div className='row' style={{ order: order }}>
            <div className='col-bhr1'>
               <DiscountDescriptionBox
                  discountDescription={
                     state.discount_list[discountCode]['DiscountDescription']
                  }
                  discountName={
                     state.discount_list[discountCode]['DiscountName']
                  }
                  hoverTitle={getString(
                     'product.HRImpDealDeskDiscountRow.DiscountDescriptionBox.HoverText',
                  )}
               />
            </div>
            <div className='col'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.discountDealDeskHRImp}
                  disabled={shouldDisableDiscount(state, discountCode)}
                  onChange={() =>
                     state.setDiscountDealDeskHRImp((prev) => !prev)
                  }
               />
            </div>
            <div className='col'>
               {formatFloatAsPercent(
                  state.discount_list[discountCode]['DiscountAmount'],
               )}
            </div>
         </div>
      )
}
